import { XOMETRY_VAT_ENABLED } from 'config/regions/features';
import { isEqual, omit } from 'es-toolkit/compat';
import { OrderConfirmation } from 'interfaces';
import { toJS } from 'mobx';
import { mapLotsToNested } from 'shared/part/mapLotsToNested';
import { parseDate } from 'utils/date';

import { OCFormValues } from './ocFormValues';

export const getInitialValues = (oc: OrderConfirmation) => {
  const hasDeliveryTerms = !!oc.deliveryTerms;

  const defaultValues: OCFormValues = {
    deliveryTerms: hasDeliveryTerms ? oc.deliveryTerms : undefined,
    deliveryDate: oc.deliveryDate ? parseDate(oc.deliveryDate) : undefined,
    delayReason: oc.delayReason ?? undefined,
    paymentTerms: oc.paymentTerms,
    paymentTermsDays: oc.paymentTermsDays,
    paymentTermsType: oc.paymentTermsType,
    publishedBy: oc.publishedBy,
    publishedAt: oc.publishedAt ? parseDate(oc.publishedAt) : null,
    lots: mapLotsToNested(oc.lots),
    services: oc.services,
    transportTerms: oc.transportTerms,
    transportMode: oc.transportMode,
    prepayRequired: oc.prepayRequired,
    confirmDate: parseDate(oc.confirmDate),
    billingAccount: oc.billingAccount,
    shippingAddress: oc.shippingAddress,
    positions: undefined,
  };

  const defaultValuesWithVat = {
    ...defaultValues,
    xometryVatNumberId: oc.xometryVatNumber?.id,
  };

  const initialValues: OCFormValues = XOMETRY_VAT_ENABLED ? defaultValuesWithVat : defaultValues;

  return initialValues;
};

export const isValuesDifferent = (initialValues: OCFormValues, formValues: OCFormValues): boolean => {
  const oldValues = omit(
    toJS(initialValues, {
      recurseEverything: true,
    }),
    ['xometryVatNumberId'],
  );

  const newValues = omit(
    toJS(formValues, {
      recurseEverything: true,
    }),
    ['xometryVatNumberId'],
  );

  return !isEqual(oldValues, newValues);
};
